import React from 'react';
import styled from 'styled-components';

const Value = styled.div`
  padding-left: 4px;
`;

export default Value;
